/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import axios from "axios";
import { Auth } from "aws-amplify";
import { v2, errorToObject } from "@prftesp/cle-logger";
import errorCodes from "../../../utility/errorCodes";
import { APIGateways } from "../../../utility/APIGateways";

const COMPONENT_NAME = "adminCCPServices/ConnectLookups";

const lookupCache = {};

const _makeLookupRequest = async (path) => {
	try {
		if (lookupCache[path]) {
			return lookupCache[path];
		}

		const token = (await Auth.currentSession()).getIdToken().getJwtToken();
		const response = await axios.get(`${APIGateways.connectLookupsEndpoint}/${path}`, {
			headers: {
				Authorization: token,
			},
		});
		lookupCache[path] = response.data;
		return response.data;
	} catch (error) {
		v2.error("Error while getting connect lookups", {
			additionalData: { error: errorToObject(error), data: { lookupType: path } },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.CONNECT_LOOKUPS_GET_API_ERROR,
		});
		return {};
	}
};

export const getQueues = async () => {
	const data = await _makeLookupRequest("queues");
	return data ? data.QueueSummaryList : [];
};

export const getHoursOfOperation = async () => {
	const data = await _makeLookupRequest("hoursOfOperation");
	return data ? data.HoursOfOperationSummaryList : [];
};

export const getContactFlows = async () => {
	const data = await _makeLookupRequest("contactFlows");
	return data ? data.ContactFlowSummaryList : [];
};

export const getUsers = async () => {
	const data = await _makeLookupRequest("users");
	return data ? data.UserSummaryList : [];
};

export const getPrompts = async () => {
	const data = await _makeLookupRequest("prompts");
	return data ? data.PromptSummaryList : [];
};
